export default {"src":"/_next/static/media/left-nav-icon.7801a0ae.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};